import { Modal, Button } from 'react-bootstrap';
import parse from 'html-react-parser';

export const ConsentDetailModal = (props: any) => {
  return (
    <Modal show={props?.showModal} onHide={props?.hideModal} keyboard={false}>
      <Modal.Header>
        <Modal.Title>Purpose Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <span className="font-weight-bold">Id: </span>
          {props?.purposeDetail?.purposeId}
        </p>
        <p>
          <span className="font-weight-bold">Version: </span>
          {props?.purposeDetail?.version}
        </p>
        <p>
          <span className="font-weight-bold">Title: </span>
          {props?.purposeDetail?.label}
        </p>
        <p>
          <span className="font-weight-bold">Description: </span>
          {parse(props?.purposeDetail?.description || '')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={props?.hideModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
